var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCookie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.942 19.993a4.997 4.997 0 01-4.94-4.995 4.997 4.997 0 01-4.995-4.94 5.154 5.154 0 00-3.114.502l-2.7 1.375a5.164 5.164 0 00-2.257 2.258l-1.371 2.691a5.182 5.182 0 00-.501 3.162l.472 2.98a5.177 5.177 0 001.451 2.85l2.14 2.138a5.157 5.157 0 002.84 1.448l2.996.474a5.152 5.152 0 003.146-.498l2.7-1.375a5.166 5.166 0 002.258-2.258l1.37-2.691a5.18 5.18 0 00.505-3.121zm-13.067 4.382a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm1.25-6.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm6.25 5a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5z",
    fill: "#001B28"
  })));
}

export default SvgCookie;